var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ds-status-tag",class:['ds-status-tag--' + _vm.resolved.type, 'ds-status-tag--' + _vm.size]},[(_vm.dot)?_c('i',{staticClass:"ds-status-tag__dot"}):_vm._e(),_c('span',{staticClass:"ds-status-tag__text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.resolved.label))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }